import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class HelpArticlesListRow {
  static props = ['href', 'category', 'question', 'updatedAt'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.question }}
    td.pr-4 {{ Props.category }}
    td.table-col-100[style="white-space:nowrap;"] {{ Props.updatedAt }}
  `;
}

export class HelpArticlesList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    <PageTitle title="Help">
    table.resource-table[data-empty-title="No help articles yet" data-empty-description="Answers will appear here when they are published."]
      thead
        th Question
        th.pr-4 Category
        th.table-col-100 Last Updated
      tbody#help-list-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('helpArticles'))
      .then(response => {
        appendDataToListTable('#help-list-rows', response.data, HelpArticlesListRow, this.mapItemToRowData);
      })
      .catch(error => renderListError('#help-list-rows', error, 'Help'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.question}`,
      category: item.category || '',
      question: item.question || '',
      updatedAt: Util.formatDate(item.updatedAt || item.createdAt) || ''
    };
  }
}
